import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useState } from "react";
import { post } from "@aws-amplify/api";
import { signUp, fetchAuthSession } from "@aws-amplify/auth";
import { useTranslation } from "react-i18next";
import { useWindowDimensions } from "../../helpers/helpers";
import {
  Box,
  Button,
  Divider,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";

export default function NewAccoutModal({
  open,
  setOpen,
  addToGroup,
  setOpenLoading,
  setNotificationMessage,
  setOpenNotification,
  adminApiName,
  fetchData,
}) {
  const { t } = useTranslation();

  const [lastPassword, setLastPassword] = useState("");

  function generatePassword() {
    var length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  const emptyNewUser = {
    email: "",
    given_name: "",
    family_name: "",
    phone_number: "",
  };

  const [newUser, setNewUser] = useState(emptyNewUser);

  function handleNewUserChange(event, key) {
    setNewUser({
      ...newUser,
      [key]: event.target.value,
    });
  }

  function resetData() {
    setNewUser(emptyNewUser);
  }

  async function createUser() {
    setOpenLoading(true);
    setOpen(false);
    try {
      const path = "/createUser";

      const session = await fetchAuthSession();
      const token = session.tokens?.accessToken?.toString();

      const options = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: {
          email: newUser.email,
          given_name: newUser.given_name,
          family_name: newUser.family_name,
          phone_number: newUser.phone_number,
        },
      };

      const restOperation = await post({
        apiName: adminApiName,
        path,
        options,
      });

      let parsed;
      try {
        const { body } = await restOperation.response;
        parsed = await body.json();
      } catch {
        parsed = restOperation?.data ?? restOperation;
      }

      addToGroup(parsed.User.Username, "User");
      setNotificationMessage(t("userAdded"));
      await fetchData();
    } catch (error) {
      setNotificationMessage(t("errorMessage"));
    }
    setOpenNotification(true);
    resetData();
    setOpenLoading(false);
  }

  async function signNewUser() {
    setOpenLoading(true);
    const pw = generatePassword();
    try {
      const createdUser = await signUp({
        username: newUser.email,
        password: pw,
        options: {
          userAttributes: {
            given_name: newUser.given_name,
            family_name: newUser.family_name,
            phone_number: newUser.phone_number,
          },
          autoSignIn: true,
        },
      });

      addToGroup(createdUser.userId, "User");
      setNotificationMessage(t("userAdded"));
      setLastPassword(pw);
      getUsersWithGroup();
    } catch (error) {
      setNotificationMessage(t("errorMessage"));
    }
    setOpenNotification(true);
    setOpenLoading(false);
  }

  const { height, width } = useWindowDimensions();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 550,
    bgcolor: "background.paper",
    borderRadius: 5,
    boxShadow: 24,
    pb: 4,
    pt: 1,
    maxWidth: width,
  };

  const textFieldSx = { width: 400, mb: 2, maxWidth: width - 20 };

  return (
    <div>
      <Modal
        open={open}
        //onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableAutoFocus={true}
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <IconButton
              color="secondary"
              sx={{ mr: 1 }}
              onClick={() => {
                setLastPassword("");
                setOpen(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: 1,
            }}
          >
            <Typography sx={{ fontSize: 18, userSelect: "none" }}>
              {t("addUser")}
            </Typography>
            <Divider flexItem sx={{ mb: 4 }} />
            <TextField
              required
              color="secondary"
              InputLabelProps={{
                shrink: true,
              }}
              label="E-Mail"
              variant="outlined"
              size="small"
              sx={textFieldSx}
              value={newUser.email}
              onChange={(event) => handleNewUserChange(event, "email")}
              helperText={t("mailm")}
            />
            <TextField
              color="secondary"
              InputLabelProps={{
                shrink: true,
              }}
              label={t("prenameo")}
              variant="outlined"
              size="small"
              sx={textFieldSx}
              value={newUser.given_name}
              onChange={(event) => handleNewUserChange(event, "given_name")}
            />
            <TextField
              color="secondary"
              InputLabelProps={{
                shrink: true,
              }}
              label={t("surnameo")}
              variant="outlined"
              size="small"
              sx={textFieldSx}
              value={newUser.family_name}
              onChange={(event) => handleNewUserChange(event, "family_name")}
            />
            <TextField
              color="secondary"
              InputLabelProps={{
                shrink: true,
              }}
              label={t("mobileo")}
              variant="outlined"
              size="small"
              sx={textFieldSx}
              value={newUser.phone_number}
              onChange={(event) => handleNewUserChange(event, "phone_number")}
              helperText={t("phoneFormat")}
            />
            <Button
              sx={{ mt: 1 }}
              color="secondary"
              variant="contained"
              size="small"
              onClick={() => createUser()}
            >
              {t("createUser")}
            </Button>
            {/* Not longer used, only relevant if signUp() function is used again. */}
            {lastPassword && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  mt: 3,
                }}
              >
                <Typography sx={{ userSelect: "none" }}>
                  {t("pwUser")}
                </Typography>
                <Typography sx={{ userSelect: "auto", ml: 2 }}>
                  {lastPassword}
                </Typography>
                <IconButton
                  sx={{ ml: 0.75 }}
                  aria-label="delete"
                  size="small"
                  onClick={() => navigator.clipboard.writeText(lastPassword)}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
